import { getActiveRegion } from 'api-client/helpers'
import { ApplicationCredentialType, getApplicationSecretName } from '../secrets/helper'

interface KubeadmConfigTemplateParams {
  name: string
  namespace: string
  flavor: string
  clusterName: string
  storage: string
  network: string
  subnet?: string
  imageName: string
  storageSize?: number
  allowedAddressesPools?: string[]
  sourceType?: string
  type?: string
  sizeGiB?: number
}

export const createKaapiOpenStackMachineTemplateBody = ({
  name,
  namespace,
  flavor,
  network,
  subnet,
  imageName,
  clusterName,
  storage,
  storageSize = 100,
  allowedAddressesPools = [],
  sizeGiB,
  type,
  sourceType,
}: KubeadmConfigTemplateParams) => {
  return {
    apiVersion: 'infrastructure.cluster.x-k8s.io/v1beta1',
    kind: 'OpenStackMachineTemplate',
    metadata: {
      name,
      namespace,
      labels: {
        'pcd-kaapi.pf9.io/region': getActiveRegion(),
      },
    },
    spec: {
      template: {
        spec: {
          flavor,
          image: {
            filter: {
              name: imageName,
            },
          },
          serverMetadata: [
            {
              key: 'clusterName',
              value: clusterName,
            },
            {
              key: 'nodePoolName',
              value: name,
            },
          ],
          identityRef: {
            name: getApplicationSecretName(ApplicationCredentialType.IdentityRef),
            cloudName: 'openstack',
          },
          ports: [
            {
              allowedAddressPairs: allowedAddressesPools?.map((pool) => ({
                ipAddress: pool,
              })),
              network: {
                id: network,
              },
              fixedIPs: [
                {
                  subnet: {
                    id: subnet,
                  },
                },
              ],
            },
          ],
          ...(sourceType === 'volume' && {
            rootVolume: {
              availabilityZone: {
                from: 'Name',
                name: 'nova',
              },
              type: type || storage,
              sizeGiB: sizeGiB || storageSize,
            },
          }),
        },
      },
    },
  }
}
